export default "__VITE_ASSET__C0hb$sXz__"